<!--
 * @Descripttion: 
 * @version: 
 * @Author: Terry
 * @Date: 2020-06-04 17:18:56
 * @LastEditors: Terry
 * @LastEditTime: 2022-05-23 22:51:00
-->
<template>
       <div class="top">
          <!-- 最左logo文字 -->
          <div class="top-container">
            <span class="header-logo" >
              <!-- <img
                class="float-left"
                src="@/assets/media/image/light-logo.png"
                alt="..."
              /> -->
              <span class="logo-text float-left m-l-10">智慧建筑后台</span>
            </span>
          </div>
        <!-- 中间项目名称 -->
           <div class="prjName">
              <h1 class="text-white">项目列表</h1> 
            </div>
            <!-- 最右时间 -->
          <div class="top-date">
            <span class="exit" @click="logout()">
            退出
          </span>
          </div>
        </div>
</template>

<style lang="scss" scoped>
.exit{
  color: white;
  float: right;
  margin-right: 30px;
  line-height: 60px;
  font-size: 16px;
  cursor: pointer;
  &:hover{
    color: #dad8d8;
  }
}
.top {
  height: 60px;
  padding: 0 20px;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.prjName{
  color: transparent;
	-webkit-text-fill-color: #fff;//文字色
	font-weight: 700;
	-webkit-text-stroke: 3px rgba(115, 97, 97, 0.143);//边框色
  h1{
    text-overflow:ellipsis;
    white-space: nowrap;//禁止换行
    overflow: hidden;
    width: 100%;
  }
  width: 55%;
  color: white;
  text-align: center;
  
}
.top-container {
  height: auto;
  display: flex;
  justify-content: space-around;
}
.top-date {
  text-align: right;
  
  font-size: 27px;
  color: #cecdce;
}
.header-logo {
  align-items: center;
  display: flex;
}
.header-logo img {
  width: 40px;
  height: 40px;
}
.logo-text {
  // line-height: 60px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
}

</style>
<script>
export default {
  data() {
    return {
      //右侧头像
      index: null,
      avatar: "",
      exit: "退出登录",
      moduleShow: false,
      list: [],
      pageLoad: true,
      module: "",
      status: null,
    };
  },
  methods: {
    //退出登录
    logout() {
      sessionStorage.clear();
      this.$router.push({ name: "login" });
    },
  },
  mounted() {
    this.avatar = sessionStorage.getItem("avatarUrl");
  },
};
</script>
